import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-toolbar-section',
    templateUrl: './toolbar-section.component.html',
    styleUrls: ['./toolbar-section.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ToolbarSectionComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
